import api from '../../components/api'
import { UnbillableCategory } from './unbillableCategory'

export const getUnbillableCategories = async () => {
  const response = await api.get<UnbillableCategory[]>('/web/unbillable-categories')
  return response.data
}

export const updateUnbillableCategory = async (unbillableCategory: UnbillableCategory) => {
  await api.post<UnbillableCategory>('/web/unbillable-categories', unbillableCategory)
}

export const deleteUnbillableCategory = async (id: string) => {
  await api.delete(`/web/unbillable-categories/${id}`)
}